export enum SignupMode {
	EDUCATION = 'EDUCATION',
	STANDARD = 'STANDARD',
	GUEST_REVIEW = 'GUEST_REVIEW'
}
